import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TrainingGoal } from '@cf-shared/enums';
import { FoodHeader } from '@cf-shared/data-model/food';
import { NutritionPlanData } from 'components/cs-nutrition-plan-card/nutrition-plan-compute';
import { SetDetailInfo } from 'components/cs-log-detail-popover/cs-log-detail-popover';
import { MuscleVolumeEntry, WorkoutsOverviewData } from 'services/workout-loader.service';

// sample sets for the last-workout detail, shown inline here and in the popover the Alert Tests card opens
export const SAMPLE_LOG_DETAIL_SETS: SetDetailInfo[] = [
  { setText: 'Set 1', dataText: '80 kg x 8' },
  { setText: 'Set 2', dataText: '80 kg x 7', userNotes: 'Felt heavy' },
];

// The Content card's body on the Test UI Components page (#6020): markdown, store badges, nutrition
// and training summaries, food cards and the workout overview, with literal sample data.
@Component({
  selector: 'cs-test-content-card',
  host: { class: 'showcase-card-body' },
  templateUrl: 'cs-test-content-card.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsTestContentCardComponent {
  readonly TrainingGoal = TrainingGoal;

  readonly nutritionPlan: NutritionPlanData = {
    dailyAvg: '2400 kcal',
    protein: '180 g',
    carbs: '250 g',
    fat: '70 g',
    fiber: '30 g',
  };
  readonly upperBodyVolume: MuscleVolumeEntry[] = [{ name: 'Chest', volume: 12 }, { name: 'Back', volume: 14 }, { name: 'Shoulders', volume: 10 }];
  readonly lowerBodyVolume: MuscleVolumeEntry[] = [{ name: 'Quads', volume: 10 }, { name: 'Hamstrings', volume: 8 }];
  readonly sampleFood: FoodHeader = { _id: 'food/test-ui-components-banana', name: 'Banana' };
  readonly recentMeals: FoodHeader[] = [
    { _id: 'meal/test-ui-components-1', name: 'Chicken and Rice', description: 'Yesterday', meal: true },
    { _id: 'meal/test-ui-components-2', name: 'Oats with Berries', description: '2 days ago', meal: true },
  ];
  readonly logDetailSets = SAMPLE_LOG_DETAIL_SETS;
  readonly workoutsOverview: WorkoutsOverviewData = {
    expanded: true,
    dailyAvg: '55 min',
    letters: 'A B',
    overallExercises: '6 exercises',
    overallSets: '18 sets',
    allLetters: 'A B',
    list: [
      { letter: 'A', exercises: [
        { name: 'Bench Press', sets: 3, useMyoReps: false, rmTesting: false },
        { name: 'Barbell Row', sets: 3, useMyoReps: true, rmTesting: false },
      ] },
      { letter: 'B', exercises: [
        { name: 'Squat', sets: 4, useMyoReps: false, rmTesting: true },
      ] },
    ],
  };
  selectedWorkout = 'A';
}
